var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8615_3112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7311 4.70605H1.21008C0.484034 4.70605 0 5.08253 0 5.64723C0 6.21194 0.484034 6.58841 1.21008 6.58841H15.7311C16.4571 6.58841 16.9412 6.21194 16.9412 5.64723C16.9412 5.08253 16.4571 4.70605 15.7311 4.70605Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7311 10.353H1.21008C0.484034 10.353 0 10.7295 0 11.2942C0 11.8589 0.484034 12.2354 1.21008 12.2354H15.7311C16.4571 12.2354 16.9412 11.8589 16.9412 11.2942C16.9412 10.7295 16.4571 10.353 15.7311 10.353Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8615_3112"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.9412,
    height: 16.9412,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.908c0ea12b283c2c56f79fdf4b487e93.svg";
export { ForwardRef as ReactComponent };